import { Component, OnInit } from '@angular/core';
import { Rebate } from '../../../../classes/Rebate';
import { Supplier } from '../../../../classes/Supplier';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-edit-rebate',
  templateUrl: './edit-rebate.component.html',
  styleUrls: ['./edit-rebate.component.scss']
})
export class EditRebateComponent implements OnInit {

  isSubmitButtonDisabled: boolean = false;
  id: number;
  contentVisible: boolean = false;
  editRebate: Rebate = new Rebate( );
  suppliersList: Supplier[] = [];

  hasNotes: boolean = false;
  notes: any;
  isRequiredNotesField: boolean = true;
  isNotesWasEdited: boolean = false;

  rebatePDFName: string = '';

  availableRoles: string[] = [ 'admin', 'installer' ];
  isAvailable: boolean = true;

  selectParams: any = {
    id: 'inputSupplier',
    isRequired: true,
    change: ( event ) => { this.editRebate.supplier_id = event.value; },
    options: [ { text: '', value: '' } ]
  };

  constructor ( 
    private route: ActivatedRoute,
    private model: ModelService,
    public global: GlobalService,
    private alerts: AlertsService,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Edit Rebate/Incentive' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) { 
    this.route.params.subscribe(params => {
      this.id = +params['id'];
      this.model.getSuppliersData( ( data ) => {
        this.suppliersList = data;
        this.selectParams.options = [ { text: '', value: '' } ];
        data.forEach( _sp => { this.selectParams.options.push( { text: _sp.name, value: _sp.id } ); });
        this.model.getRebateDataByID( this.id, ( rebate ) => {
          this.contentVisible = true;
          rebate.notes = '';
          this.editRebate = rebate;
          this.editRebate.id = this.id;
          if (rebate.PDF) {
            this.rebatePDFName = rebate.PDF.substring(rebate.PDF.lastIndexOf('/')+1);
          }
          this.getNotes( );
        });
      }, { 'sorting': 'name' });
    });
  }

  changePDF ( $event ) {

    let file: any = $event.target.files[0];

    if ( !file ) return;

    this.global.showPreloader( );
    let formData = new FormData( );
    formData.append( 'pdf', file, file.fileName );
    this.model.uploadRebatesPDF( formData, file.fileName, ( response ) => {
      this.editRebate.PDF = response.url;
      this.rebatePDFName = response.url.substring(response.url.lastIndexOf('/')+1);
      this.global.hidePreloader( );
    });
  }

  getNotes ( ) {
    this.model.getNotes( 'rebate', this.id, ( notes ) => {
      this.notes = notes;
      this.hasNotes = notes.length != 0;
    });
  }

  addNote ( ) {
    this.model.addNote( 'rebate', this.id, this.editRebate.notes, ( response ) => {
      this.getNotes( );
      this.isRequiredNotesField = false;
      this.isNotesWasEdited = true;
    });
  }

  showHistory ( ) { this.global.changeHPVisibility( true ); }

  successCallback ( ) {
    this.global.defaultSuccessMessage({ 
      html: 'Rebate information has been updated successfully', 
      redirect: '/rebates-list' 
    });
  }


  errorCallback ( message?: string ) {
    let data = {
      messageType: 'error',
      message: message || 'We got some error here...',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.isSubmitButtonDisabled = false;

  }

  submitForm ( ) {

    this.isSubmitButtonDisabled = true;
    this.model.editRebate( this.editRebate, ( response ) => {
      let _answer = response.json( ).answer;
      
      if ( _answer == 'success' ) this.successCallback( );
      else if ( _answer == 'exists' ) {
        this.errorCallback( 'Rebate/Incentive with name "' + this.editRebate.name + '" already exists' );
        this.global.defaultErrorCallback( 'Rebate/Incentive with name "' + this.editRebate.name + '" already exists' );
      } else {
        this.errorCallback( _answer );
        this.global.defaultErrorCallback( _answer );
      }
    });
    return false;
  }
  
  cancelSubmit ( ) {
    this.global.redirect( '/rebates-list' );
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/rebates/edit-rebate/edit-rebate.component.ts